'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getEnvByHost = getEnvByHost;
exports.getCurrentEnv = getCurrentEnv;
exports.getBaseHostname = getBaseHostname;
exports.getHostname = getHostname;

var NONPROD_ENVIRONMENTS = {
    dev: 1,
    beta: 1,
    kappa: 1,
    stage: 1
};

var _currentEnv = null; // Cache the call to getCurrentEnv

function isIPAddress(host) {
    return host.match(/^\d+\.\d+\.\d+\.\d+$/);
}

function getSubdomain(host) {
    if (host.indexOf('localhost') === 0) return 'dev';

    var hostTokens = host.split('.');

    if (hostTokens.length > 1) {
        for (var i = 1, max = hostTokens.length; i < max; i++) {
            if (hostTokens[i].toLowerCase().match(/^(shutterfly|tinyprints)$/)) {
                return hostTokens[i - 1].toLowerCase();
            }
        }
    }

    return null;
}

function getEnvByHost(host) {
    if (!host) {
        return 'production';
    }

    if (isIPAddress(host)) {
        return 'dev';
    }

    var subdomain = getSubdomain(host);

    if (subdomain === 'local' || subdomain === 'int') return 'dev';

    if (subdomain && NONPROD_ENVIRONMENTS[subdomain]) {
        return subdomain;
    } else {
        return 'production';
    }
}

function isBrowser() {
    try {
        if (window) return true;
    } catch (err) {
        return false;
    }
}

function getNodeEnv() {
    var env = process.env.NODE_ENV;
    if (!env) return 'dev';
    if (env === 'prod') return 'production';
    return env;
}

function _getCurrentEnv() {
    if (isBrowser()) return getEnvByHost(window.location.host);else return getNodeEnv();
}

function getCurrentEnv() {
    if (_currentEnv) {
        return _currentEnv;
    }

    _currentEnv = _getCurrentEnv();

    return _currentEnv;
}

function getBaseHostname() {
    var env = getCurrentEnv();
    if (env === 'production') return 'shutterfly.com';else return env + '.shutterfly.com';
}

function getHostname(subdomain) {
    return subdomain + '.' + getBaseHostname();
}

//# sourceMappingURL=index.js.map